<template>
  <b-modal
    v-model="_value"
    dialog-class="mandala-evaluation-modal"
    header-class="mandala-evaluation-modal__header"
    content-class="mandala-evaluation-modal__content"
    :body-class="['mandala-evaluation-modal__body', { 'is-locked': !canShowBody }]"
    hide-footer>
    <template #modal-header>
      <IconButton
        class="mandala-evaluation-modal__header__close-button top"
        color="white"
        icon="close"
        @click="_value = false" />
      <IconButton
        v-if="canShowBody"
        class="mandala-evaluation-modal__header__close-button bottom"
        color="white"
        icon="close"
        @click="_value = false" />
    </template>
    <template
      #default>
      <MandalaEvaluationModalBody
        :is-any-manager="isAnyManager"
        :is-mine="isMine"
        :mandala-evaluations="mandalaEvaluations"
        :mandala-goal-template="mandalaGoalTemplate" />
    </template>
  </b-modal>
</template>

<script>
import { differenceInDays, differenceInMonths } from 'date-fns'
import IconButton from '@/components/parts/IconButton.vue'
import MandalaEvaluationModalBody from '@/components/view/MandalaEvaluationModalBody.vue'
import mandalaEvaluationVisibility from '@/components/mixin/mandalaEvaluationVisibility'
export default {
  components: {
    IconButton,
    MandalaEvaluationModalBody
  },
  mixins: [mandalaEvaluationVisibility],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    mandalaEvaluations: {
      type: Array,
      required: true
    },
    mandalaGoalTemplate: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean,
      default: false
    },
    isAnyManager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    latestMandalaEvaluation() {
      return this.mandalaEvaluations[0] || null
    },
    targetDateMonthDiff() {
      return differenceInMonths(new Date(this.latestMandalaEvaluation.targetDate), new Date())
    },
    targetDateDiff() {
      return differenceInDays(new Date(this.latestMandalaEvaluation.targetDate), new Date())
    },
    /**
     * 表示に必要なデータのみフィルタリング
     */
    filteredEntryItems() {
      return this.latestMandalaEvaluation.mandalaGoalSelfEvaluationEntries
        .filter(entry => !!entry.name || entry.mandalaGoalSelfEvaluationActionGoals.some(actionGoal => !!actionGoal.name))
        .map(entry => ({
          ...entry,
          mandalaGoalSelfEvaluationActionGoals: entry.mandalaGoalSelfEvaluationActionGoals.filter(actionGoal => !!actionGoal.name)
        })
        )
    }
  }
}
</script>

<style lang="scss">
.mandala-evaluation-modal__logo {
  width: 50px;
}
.mandala-evaluation-modal {

  &__final-goal {
    display: flex;
    align-items: center;
    background-color: $white;
    border-radius: 0.3em;
    padding: 16px;
    margin-bottom: 12px;
    font-size: $fs-nm;
    font-weight: bold;
  }

  &__entries-wrapper {
    background-color: $white;
    border-radius: 0.3em;
    padding: 16px;
  }
  
  &__content.modal-content{
    position: relative;
    background-color: transparent;
    border: none;
    margin-top: calc(env(safe-area-inset-top));
    margin-bottom: 60px;
  }
  
  &__header.modal-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: transparent;
    margin-bottom: 12px;
    border: none;
    padding: 0;
  }
  &__body.modal-body {
    background-color: transparent;
    padding: 0;
    font-size: 12px;
    font-weight: bold;
    &.is-locked {
      background-color: transparent;
    }
  }
  &__entry-list {
    &-item {
      font-size: $fs-lg;
      padding: 16px 0;
      border-bottom: 1px solid $grey02;
      
      &-name {
        padding-bottom: 8px;
      }
      &:first-child {
        padding: 0 0 16px 0;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
  &__action-goal-list {
    list-style-type: none;
    padding-left: 0;
    &-item {
      font-size: $fs-m;
      padding-bottom: 8px;
    }
  }

  .mandala-evaluation-modal__header__close-button {

    &.bottom {
      position: absolute;
      bottom: -40px;
      right: 0;
    }
  }
}
</style>